import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container, Row, Col, Card, CardBody,
} from 'reactstrap';

import { ButtonLink } from 'components/Button';
import { PhoneIcon, ChevronRightIcon } from './components/Icons';
import './style.scss';

/**
 * "Let's secure your account" — the entry point where the user chooses how to
 * receive their 2FA codes. Per spec, SMS/Text is intentionally NOT offered.
 * Authenticator app is recommended; email is offered as a low-key inline
 * alternative link rather than a boxed option.
 */
const TwoFactorSetupOptions = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Best-effort: carry the user's email into the setup screens if it was
  // passed through navigation state (e.g. from the sign-in / verification flow).
  const email = location.state?.email;
  const navState = email ? { state: { email } } : undefined;

  return (
    <div className="two-factor-page">
      <Container fluid>
        <Row>
          <Col>
            <Card className="tf-card">
              <CardBody className="p-4">
                <div className="tf-header-row mb-3">
                  <h3 className="tf-title mb-0">Let&apos;s secure your account</h3>
                  <span className="tf-pill">Required</span>
                </div>
                <p className="tf-subtitle">
                  Before you continue, set up two-factor authentication to protect your loan and
                  payment details. Choose how you&apos;d like to receive your codes.
                </p>

                {/* Recommended: Authenticator app */}
                <button
                  type="button"
                  className="tf-option tf-option--primary"
                  onClick={() => navigate('/two-factor/setup-authenticator', navState)}
                >
                  <span className="tf-option__icon"><PhoneIcon /></span>
                  <span className="tf-option__body">
                    <span className="tf-option__title">
                      Authenticator app
                      <span className="tf-badge">Recommended</span>
                    </span>
                    <p className="tf-option__desc">Google Authenticator, Authy, and more</p>
                    <ButtonLink
                      className="tf-link d-inline-block mt-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate('/two-factor/authenticator-info');
                      }}
                    >
                      New to this? See how it works
                    </ButtonLink>
                  </span>
                  <span className="tf-option__chevron"><ChevronRightIcon /></span>
                </button>

                {/* Alternative: email — plain inline text link, not a boxed option. */}
                <p className="tf-alt-text mt-3">
                  Prefer
                  {' '}
                  <ButtonLink
                    className="tf-link d-inline"
                    onClick={() => navigate('/two-factor/verify-by-email', navState)}
                  >
                    email
                  </ButtonLink>
                  {' '}
                  instead? You can still verify that way.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TwoFactorSetupOptions;
